import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environment';
import { BusinessInfo } from '../../onboarding/classes/business-info';

@Injectable()
export class BusinessinfoService {

  constructor(private http: Http) { }

  addBusinessInfo(orgId: number, info: BusinessInfo) {
    let data = { company_information: info, commit: 'Add', organization_id: orgId };
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.post(`${environment.organizationsUrl}${orgId}/${environment.companyInfoUrl}`, data, options)
      .map(res => res.json())
  }

  editBusinessInfo(orgId: number, id: number, info: BusinessInfo) {
    let data = { company_information: info, commit: 'Add', organization_id: orgId, id };
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.patch(`${environment.organizationsUrl}${orgId}/organization_setups/company_informations/${id}.json`, data, options)
      .map(res => res.json())
  }

  getBusinessInfo(orgId: number) {
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.get(`${environment.organizationsUrl}${orgId}/${environment.companyInfoUrl}`, options)
      .map(res => res.json())
  }

}



// WEBPACK FOOTER //
// ./src/app/onboarding/services/businessinfo.service.ts